import React, { forwardRef } from 'react';
// TODO: this is kept as a component within Link for now for the sake of faster
// iterations, but we will eventually want to move this into Origami and merge
// this with the <FileInput> component.
// Uses `forwardRef` to allow a ref to be attached to the <input> element. The
// intended use case here is to have a separate button trigger the opening of
// the file picker, but triggering a click event on the ref.
var DocumentUploadsFileInput = forwardRef(function (_a, ref) {
    var accept = _a.accept, capture = _a.capture, _b = _a.multiple, multiple = _b === void 0 ? false : _b, onFilesAdded = _a.onFilesAdded, _c = _a.hidden, hidden = _c === void 0 ? false : _c;
    return (React.createElement("input", { ref: ref, type: "file", hidden: hidden, accept: accept, capture: capture, multiple: multiple, onChange: function (e) {
            var files = e.target.files;
            if (!(files === null || files === void 0 ? void 0 : files.length)) {
                // Cancelled, nothing selected from the file picker
                return;
            }
            // Convert `FileList` to `File[]` for array iteration capabilities to
            // make this easier to work with.
            onFilesAdded(Array.from(files));
            // This is needed in order to prevent the last uploaded file from being
            // "saved", which allows the same file to be re-added when subsequently
            // reselected. It doesn't make much of a difference either way, but the
            // reasoning here is that we should either completely support duplicate
            // file detection (e.g. via file hashes) or not at all -- having an
            // "in-between" state where only the last duplicate is prevented could
            // be confusing to the user.
            e.target.value = '';
        } }));
});
export default DocumentUploadsFileInput;
